import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RegionsService, TRegion } from 'src/app/services/regions.service';

export interface TExtendedHCPDownloadParams {
  downloadCallback?: (options?: {
    geography?: string;
    withNetwork?: boolean;
  }) => void;
}

@Component({
  selector: 'app-extended-download',
  templateUrl: './extended-download.component.html',
  styleUrls: ['./extended-download.component.scss'],
})
export class ExtendedDownloadComponent implements OnInit {
  public downloadSettingsForm: FormGroup;
  public regions: TRegion[] = [];
  public regionsFiltered: TRegion[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ExtendedDownloadComponent>,
    private _regionsService: RegionsService,
    @Inject(MAT_DIALOG_DATA) public data: TExtendedHCPDownloadParams
  ) {
    this.downloadSettingsForm = this.fb.group({
      geography: [null, Validators.required],
      withNetwork: [false],
    });
  }

  ngOnInit(): void {
    this.regions = this._regionsService.getCountriesOnly();
    this.regionsFiltered = this.regions;
  }

  get geography() {
    return this.downloadSettingsForm.get('geography') as FormControl;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.downloadSettingsForm.valid) {
      const geographyRegion = this.downloadSettingsForm.value
        .geography as TRegion;
      const withNetwork = this.downloadSettingsForm.value.withNetwork;

      this.data.downloadCallback?.({
        geography: geographyRegion?.value,
        withNetwork,
      });
      this.dialogRef.close();
    } else {
      this.downloadSettingsForm.markAllAsTouched();
    }
  }
}
